import React from 'react'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import PageSection from '../../../../../../features/components/PageSection'
import Icon from '../../../../../../components/Icon'
import Circles from './Circles'
import { ReactComponent as CircleFilled } from '../../../../../../assets/icons/sroi/circleFilled.svg'
import HoverHelpTextIcon from '../../../../../../features/components/HoverHelpTextIcon'

import { useSroiReportCurrencySymbol } from '../../../hooks'
import { formatNumberToShort } from '../../../../helpers'

import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'
import { helpTexts } from '../../../constants'

import usePanelsStyles from '../styles'
import useStyles from './styles'

const TotalPanel = () => {
  const { t } = useTranslation()

  const panelsClasses = usePanelsStyles()
  const classes = useStyles()

  const {
    total_investment: totalInvestment,
    total_impact: totalImpact,
    sroi
  } = useSelector(socialReturnOnInvestmentReportSelector)
  const currencySymbol = useSroiReportCurrencySymbol()

  return (
    <PageSection className={classnames(panelsClasses.panel, classes.totalPanel)}>
      <div className={panelsClasses.leftSide}>
        <h5 className={panelsClasses.valueTitle}>
          {t('Investment')} <HoverHelpTextIcon color={'#fff'} helpText={helpTexts.investment} />
        </h5>
        <div className={classnames(panelsClasses.value, classes.investmentValue)}>{currencySymbol}</div>
        <div className={classnames(panelsClasses.value, classes.investmentValue)}>
          {formatNumberToShort(totalInvestment, 2)}
        </div>

        <h5 className={classnames(panelsClasses.valueTitle, classes.socialValueTitle)}>
          {t('Social Value')} <HoverHelpTextIcon color={'#fff'} helpText={helpTexts.socialValue} />
        </h5>

        <div className={classnames(panelsClasses.value, classes.socialValue)}>{currencySymbol}</div>
        <div className={classnames(panelsClasses.value, classes.socialValue)}>
          {formatNumberToShort(totalImpact, 2)}
        </div>
      </div>
      <div className={classnames(panelsClasses.rightSide, classes.rightSide)}>
        <Icon className={classes.icon}>
          <CircleFilled />
        </Icon>
        <div className={classes.rightSideValue}>{currencySymbol} 1</div>
        <div className={classes.rightSideText}>{t('Amount Invested')}</div>
        <Circles filledCount={sroi} />

        <div className={classes.rightSideValue}>
          {currencySymbol} {formatNumberToShort(sroi, 2)}
        </div>
        <div className={classnames(classes.rightSideText, classes.sroiText)}>{t('Social Return On Investment')}</div>
      </div>
    </PageSection>
  )
}

export default TotalPanel
